import styled from "styled-components";
import { h2Styling } from "../../../../designSystem/typography/Heading";

export const ReportFieldHeader = styled.h2`
    ${h2Styling}
    margin-bottom: 8px;
    padding: 8px;
`;